import styled from 'styled-components';
export const BKJEllipsisMenuIconWrapper = styled.button `
  min-height: 38px;
  height: 38px;
  width: 38px;
  min-width: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  color: inherit;
  &:hover {
    cursor: pointer;
  }
`;
//# sourceMappingURL=BKJEllipsisMenu.styled.js.map